
import { Component } from 'vue-property-decorator';
import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';
import MenuPriceAddEdit from './MenuPriceAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class MenuPriceListItem {
  id: string = '';
  menuItemCode: string = '';
  priceType: string = '';
  price: string = '';
}

@Component({
  components: {
    editor: MenuPriceAddEdit
  }
})
export default class MenuPriceList extends RemoteDataTable<MenuPriceListItem> {
  public pageTitle: string = 'Menu Price List';

  public newButtonText: string = 'New MenuPrice';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'menuItemCode', label: 'Menu Item Code' }),
    new RemoteDataField({ key: 'priceType', label: 'Price Type' }),
    new RemoteDataField({ key: 'price', label: 'Price' })
  ];

  // to get page data
  get items(): MenuPriceListItem[] {
    return this.$store.getters.GetAllMenuPrice;
  }
  get paging(): MenuPriceListItem[] {
    return this.$store.getters.PagingMenuPrice;
  }
  get sorting(): MenuPriceListItem[] {
    return this.$store.getters.SortingMenuPrice;
  }
  get filtering(): MenuPriceListItem[] {
    return this.$store.getters.FilteringMenuPrice;
  }

  resetSorting() {
    this.sortingChanged({ sortBy: '', sortDesc: '' });
  }

  resetFilter() {
    this.filterChanged(true);
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingMenuPrice', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringMenuPrice', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.menuPrice.pagingMenuPrice.page = 1;
    }
    this.$store.dispatch('GetAllMenuPrice');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteMenuPrice', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.menuPrice.pagingMenuPrice.size = page;
    this.$store.dispatch('GetAllMenuPrice');
  }
}
